import * as React from 'react';
import { auth } from "../config/firebase";
import { signOut } from "firebase/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import Skeleton from '@mui/material/Skeleton';
import SignInButton from "./SignInButton.js";
import Settings from '@mui/icons-material/Settings';

export default function AccountMenu(props) {

  const { setOpenSettings } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMyBBCode = () => {
    setAnchorEl(null);
    window.location.reload();
  };

  const handleSettings = () => {
    setOpenSettings(true);
  }

  const logout = async () => {
    try {
      setAnchorEl(null);
      await signOut(auth);
    } catch (err) {
      console.error(err);
    }
  };

  const userImg = auth?.currentUser?.photoURL;

  const [authUser, setAuthUser] = React.useState(null);

  React.useEffect(() => {
    auth.onAuthStateChanged(u => {
      if (u) {
        setAuthUser(true);
      }
      else {
        setAuthUser(false);
      }
    });
  }, []);

  return (
    <React.Fragment>
      {authUser===false ? <SignInButton /> : 
        authUser===true ?
          <Box id="accountBubble" sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
            <Tooltip title="Account Menu">
              <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }} aria-controls={open ? 'account-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined}>
                <Avatar id="userIcon" sx={{ width: 32, height: 32 }}><img src={userImg} referrerPolicy="no-referrer" alt="User Avatar" width={32} height={32}></img></Avatar>
              </IconButton>
            </Tooltip>
          </Box> :
          <Skeleton variant="circular" sx={{ bgcolor: 'grey.800' }} width={32} height={32} />
      }
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleClose}>
          <Avatar><img src={userImg} referrerPolicy="no-referrer" alt="User Avatar" width={32} height={32}></img></Avatar> Profile
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Avatar><FontAwesomeIcon icon={faCirclePlay} /></Avatar> My Clips
        </MenuItem>
        <MenuItem onClick={handleMyBBCode}>
          <Avatar><FontAwesomeIcon icon={faCode} /></Avatar> My BBCode
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleSettings}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}